import api from "./axios";

/*
Create, read and see provider alerts
*/
// POST: create a new provider alert

export async function createProviderAlert(payload) {
  try {
    const res = await api.post("/api/v1/provider-alerts", payload);
    return res.data;
  } catch (err) {
    console.error("Error creating provider alert:", err);
    throw err;
  }
}

// GET: active alerts the user has created
export async function getActiveProviderAlerts() {
  try {
    const res = await api.get("/api/v1/provider-alerts/created");
    return res.data;
  } catch (err) {
    console.error("Error fetching active provider alerts:", err);
    throw err;
  }
}

// GET: alerts that have been fulfilled (provider available match)
export async function getFulfilledProviderAlerts() {
  try {
    const res = await api.get("/api/v1/provider-alerts/fulfilled");
    return res.data;
  } catch (err) {
    console.error("Error fetching fulfilled provider alerts:", err);
    throw err;
  }
}

// GET: full history (active + expired + fulfilled)
export async function getProviderAlertHistory() {
  try {
    const res = await api.get("/api/v1/provider-alerts/history");
    return res.data;
  } catch (err) {
    console.error("Error fetching provider alert history:", err);
    throw err;
  }
}

/*
export const ProviderAlertsApi = {
  create: createProviderAlert,
  active: getActiveProviderAlerts,
  fulfilled: getFulfilledProviderAlerts,
  history: getProviderAlertHistory,
};

//Usage
const alerts = await ProviderAlertsApi.active();

*/
